'use client'

import { useTranslate } from '@marketplace-web/i18n/i18n-feature'
import { ErrorBanner } from '@marketplace-web/business-accounts/business-accounts-ui'

const GeneralError = () => {
  const translate = useTranslate('business.registration.errors.general')

  return <ErrorBanner title={translate('title')} body={translate('body')} />
}

export default GeneralError
